/* Svensk katalog for locale-no.js (del 7 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'bg.balanceDiscrepancy': 'Saldoavvikelse',
  'bg.notCorrect': 'Inte rätt',
  'bg.reconciliationDone': 'Bankavstämningen är slutförd',
  'bg.reconciliationDoneHelp': 'Kontoutdraget är kontrollerat, bokfört och flyttat till arkivet.',
  'bg.bankLines': 'Banktransaktioner',
  'bg.reconciled': 'Avstämd',
  'bg.backToBank': 'Tillbaka till Bank',
  'bg.reopenReconciliation': 'Öppna avstämningen igen',
  'bg.bankAccountCaps': 'BANKKONTO',
  'bg.periodCaps': 'PERIOD',
  'bg.balanceAtStart': 'Saldo vid periodens början',
  'bg.balanceAtEnd': 'Saldo vid periodens slut',
  'bg.balancesMatch': 'Saldona stämmer.',
  'bg.roundingHelp': 'Detta kan bokföras på avrundningskonto 7770 utan att ändra beloppet från kontoutdraget.',
  'bg.balancesMatchContinue': 'Saldona stämmer – fortsätt',
  'bg.suggestionsHeading': 'SuperPlumma har matchat och föreslagit bokföring — du bestämmer',
  'bg.noSuggestions': 'Inga förslag väntar på godkännande.',
  'bg.continueToRest': 'Fortsätt till resten',
  'bg.noPostedDiscrepancies': 'Inga bokförda poster skapar avvikelser.',
  'bg.checkAndFix': 'Kontrollera och rätta posterna innan perioden slutförs.',
  'bg.allPaymentsHandled': 'Alla betalningar är hanterade.',
  'bg.continueToVouchers': 'Fortsätt till verifikationer',
  'bg.allPurchasesDocumented': 'Alla inköp har nödvändig dokumentation eller är markerade som utan verifikation.',
  'bg.seePurchase': 'Visa inköpet',
  'bg.withoutVoucher': 'Utan verifikation',
  'bg.linkSuggested': 'Koppla föreslagen',
  'bg.pickVoucher': 'Välj verifikation',
  'bg.continueToFinish': 'Fortsätt till slutförande',
  'bg.bankLinesTotal': 'Banktransaktioner totalt',
  'bg.linkedPosted': 'Kopplade/bokförda',
  'bg.privateMovements': 'Privata transaktioner',
  'bg.reconcileAndArchive': 'Stäm av och arkivera',
  'bg.backAndCheck': 'Tillbaka och kontrollera',
  'bg.stepModeHelp': 'Steg för steg leder dig genom en uppgift i taget. Full översikt visar allt samlat.',
  'acc.sub': 'Din profil och verksamheterna du har åtkomst till.',
  'acc.signOutHelp': 'Loggar ut dig från Plumme. Du måste logga in igen med e-post och lösenord för att fortsätta.',
  'acc.yourRole': 'Din roll',
  'acc.yourRoleHelp': 'Rollen styr vad du kan göra: Ägare har full åtkomst, Administratör styr driften, Redovisningskonsult sköter bokföringen och Läsare kan bara titta. Rollen kan skilja sig från företag till företag.',
  'acc.editProfile': 'Redigera profil',
  'acc.myBusinesses': 'Mina verksamheter',
  'acc.myBusinessesHelp': 'Företagen du har åtkomst till i Plumme. Etiketten visar din roll i varje företag. Tryck på ett företag för att öppna bokföringen.',
  'acc.personalFinanceHelp': 'Privatekonomi är en egen klienttyp för personlig ekonomi och hushåll, åtskild från företagens bokföring.',
  'acc.goToPersonalFinance': 'Gå till privatekonomi',
  'acc.ownPersonalClient': 'Egen privatekonomiklient',
  'acc.myEmployers': 'Mina arbetsgivare',
  'acc.myEmployersHelp': 'Verksamheter där du är anställd (inte nödvändigtvis sköter bokföringen för). Här hittar du så småningom lönebesked, avtal och din egen personalsida.',
  'acc.employerPortalAccess': 'Verksamheter du har åtkomst till personalportalen för.',
  'acc.changePicture': 'Byt bild',
  'acc.removePicture': 'Ta bort bild',
  'acc.photoUploading': 'Laddar upp …',
  'acc.photoRemoving': 'Tar bort …',
  'acc.photoSaved': 'Profilbilden har uppdaterats.',
  'acc.photoRemoved': 'Profilbilden har tagits bort.',
  'acc.photoWrongType': 'Välj en bild i PNG, JPG eller WebP.',
  'acc.photoEmpty': 'Bildfilen är tom.',
  'acc.photoTooLarge': 'Bilden är för stor. Max 2 MB.',
  'acc.photoUploadFailed': 'Det gick inte att ladda upp profilbilden.',
  'acc.photoRemoveFailed': 'Det gick inte att ta bort profilbilden.',
  'acc.photoUnavailable': 'Profilbild är inte tillgänglig just nu.',
  'acc.fullName': 'Fullständigt namn',
  'acc.phoneFromLogin': 'Telefon från inloggning',
  'acc.changePassword': 'Ändra lösenord',
  'acc.changes': 'Ändringar',
  'acc.noChangeDetails': 'Inga extra ändringsdetaljer har sparats för denna händelse.',
  'acc.logSub': 'Vad som har gjorts i bokföringen - och av vem.',
  'acc.logFilterHelp': 'Filtrera loggen på period, område (t.ex. Faktura, Lön, Moms) och vilken användare som utförde åtgärden.',
  'acc.area': 'Område',
  'acc.areaHelp': 'Vilken del av bokföringen åtgärden gäller - t.ex. Faktura, Inköp, Lön eller Moms. En åtgärd kan beröra flera områden.',
  'acc.user': 'Användare',
  'acc.userHelp': 'Personen som utförde åtgärden, med sin roll. Så ser du vem som står bakom varje ändring.',
  'acc.sentLinkTo': 'Vi har skickat en länk till',
  'bud.annualBudget': 'Årsbudget',
  'bud.suggestion': 'Budgetförslag',
  'bud.createSuggestion': 'Skapa förslag',
  'bud.startSimpleQuestions': 'Börja med enkla frågor',
  'bud.fillRelevant': 'Fyll bara i det som är relevant. Månadsbelopp räknas om till årsbudget.',
  'bud.businessDescription': 'Beskrivning av verksamheten',
  'bud.businessDescriptionPh': 'T.ex. Transportföretag för 2027 med 2 skåpbilar, 2 anställda, kontorshyra 8 000/mån och mer intäkter på sommaren.',
  'bud.howToBudget': 'Hur du skapar en budget',
  'bud.howToBudgetHelp': 'Välj metod: med ”Manuellt” lägger du in kontona själv, med ”Förslag” svarar du på några enkla frågor och får ett utkast, och med ”AI-förslag” beskriver du verksamheten med egna ord så skapar Plumme ett utkast.',
  'bud.budgetedResult': 'Budgeterat resultat',
  'bud.budgetedResultHelp': 'Resultatet du har budgeterat för hela året — summan av budgeterade intäkter minus budgeterade kostnader. Detta är målet du styr mot.',
  'bud.actualResult': 'Faktiskt resultat',
  'bud.actualResultHelp': 'Det faktiska resultatet som har bokförts hittills i år — verkliga intäkter minus verkliga kostnader. Jämför med budgeten för att se om du ligger till som planerat.',
  'bud.postedSoFar': 'bokfört hittills',
  'bud.varianceToPeriod': 'Avvikelse mot period',
  'bud.varianceToPeriodHelp': 'Skillnaden mellan faktiskt och budgeterat resultat hittills. Negativ avvikelse betyder att du ligger under budget, positiv att du ligger över.',
  'bud.incomeTarget': 'Intäktsmål',
  'bud.incomeTargetHelp': 'Hur stor andel av årets budgeterade intäkter du har nått hittills — faktiskt fakturerad intäkt delat med budgeterad intäkt.',
  'bud.ofTargetReached': 'av målet uppnått',
  'bud.viewHelp': 'Byt vy: ”Översikt” visar ackumulerat resultat och största avvikelser, ”Analys” visar intäkter mot kostnader och resultat per månad, och ”Budget per kategori” är där du lägger in och ändrar beloppen.',
  'bud.accumulatedResult': 'Ackumulerat resultat',
  'bud.accumulatedResultHelp': 'Diagrammet visar resultatet som byggs upp månad för månad under året. Den streckade linjen är budgeten, den heldragna är faktiskt bokfört — så ser du om du följer planen.',
  'bud.budgetAtYearEnd': 'Budget vid årets slut',
  'bud.accumulated': 'ackumulerat',
  'bud.actualSoFar': 'Faktiskt hittills',
  'bud.posted': 'bokfört',
  'bud.varianceSoFar': 'Avvikelse hittills',
  'bud.largestVariance': 'Största avvikelse',
  'bud.largestVarianceHelp': 'Kontot som avviker mest från budgeten hittills i år. Bra för att snabbt se var du ligger mest över eller under det du planerade.',
  'bud.soFarThisYear': 'hittills i år',
  'bud.incomeVsCost': 'Intäkter vs. kostnader per månad',
  'bud.incomeVsCostHelp': 'Staplarna visar intäkter (grönt) mot kostnader (orange) för varje månad. Växla mellan faktiska siffror, budgeterade siffror eller båda. Tryck på en månad för att summera ett urval.',
  'bud.resultPerMonth': 'Resultat per månad',
  'bud.resultPerMonthHelp': 'Visar resultatet (intäkter minus kostnader) för varje enskild månad, budget mot utfall. Staplar ovanför mittlinjen är vinst, under är förlust.',
  'bud.actual': 'Utfall',
  'bud.actualByCategory': 'Utfall per kategori',
  'bud.actualByCategoryHelp': 'Bokförda intäkter och kostnader per konto, fördelade per månad. Siffrorna kommer från din bokföring — både verifikationer du har registrerat i Plumme och siffror från en import — och uppdateras automatiskt.',
  'bud.noActuals': 'Inga bokförda siffror för {year} ännu.',
  'bud.actualOnlyHint': 'Det här är faktiska siffror. Lägg in en budget under Budget om du vill mäta dig mot en plan.',
  'bud.byCategory': 'Budget per kategori',
  'bud.addIncome': 'Lägg till intäkt',
  'bud.addIncomeHelp': 'Lägg till en intäktskategori med ett årsbelopp — t.ex. förväntad försäljning. Beloppet fördelas på månader, som du kan justera.',
  'bud.addCost': 'Lägg till kostnad',
  'bud.addCostHelp': 'Lägg till en kostnadskategori med ett årsbelopp — t.ex. hyra, varuinköp eller programvara. Beloppet fördelas på månader, som du kan justera.',
  'bud.noCategories': 'Inga budgetkategorier ännu. Lägg till intäkt eller kostnad.',
  'bud.useLastYear': 'Använd fjolåret',
  'bud.simpleQuestions': 'Enkla frågor',
  'bud.byCategoryHelp': 'Varje rad är en budgetkategori. Beloppen för var och en av de 12 månaderna är alltid synliga och kan redigeras direkt i tabellen, med årets total till höger.',
  'bud.total': 'Totalt',
  'bud.annualTotal': 'Årstotal',
  'bud.annualTotalHelp': 'Ändrar du den här siffran direkt fördelas det nya årsbeloppet jämnt över alla 12 månader.',
  'bud.save': 'Spara',
  'bud.methodManual': 'Manuellt',
  'bud.methodSuggestion': 'Förslag',
  'bud.methodAi': 'AI-förslag',
  'bud.modeBudgeted': 'Budgeterat',
  'bud.modeBoth': 'Båda',
  'bud.forWholeYear': 'för hela {year}',
  'bud.underBudget': 'under budget',
  'bud.overBudget': 'över budget',
  'bud.legendBudgetDashed': '- - Budget',
  'bud.legendBudgetSolid': '— Budget',
  'bud.legendActual': '— Utfall',
  'bud.noVarianceYet': 'Inga avvikelser ännu',
  'bud.savedToast': 'Budget sparad',
  'bud.saveFailedToast': 'Kunde inte spara budget',
  'bud.aiModalTitle': 'AI-budget för {year}',
  'bud.aiDraftBusy': 'Skapar utkast...',
  'bud.aiDraftCreate': 'Skapa utkast med AI',
  'bud.aiDescription': 'Beskriv verksamheten med egna ord: anställda, löner, tillgångar, fasta kostnader och säsongsvariation. Ju mer detaljer, desto bättre utkast.',
  'bud.aiDraftFailedGeneric': 'Jag lyckades inte skapa ett budgetutkast från beskrivningen. Lägg till fler detaljer eller använd Förslag.',
  'bud.aiDraftAppliedToast': 'AI-utkast inlagt. Tryck på Spara när det ser rätt ut.',
  'bud.aiDraftFailed': 'AI-budgetutkastet misslyckades.',
  'bud.suggestionIntro': 'Skapa ett förslag från förra årets faktiska siffror, eller svara på några enkla frågor för en startbudget.',
  'bud.catSales': 'Försäljning av varor och tjänster',
  'bud.catPurchases': 'Varuinköp och direkta kostnader',
  'bud.catPremises': 'Lokaler',
  'bud.catSoftware': 'Programvara och utrustning',
  'bud.catAccounting': 'Redovisning och rådgivning',
  'bud.catTravel': 'Resor',
  'bud.catMarketing': 'Marknadsföring',
  'bud.catCommunication': 'Telefon, porto och kommunikation',
  'bud.otherCosts': 'Övriga kostnader',
  'bud.customCategory': 'Egen kategori',
  'bud.q.expectedIncome.label': 'Hur mycket ska du tjäna?',
  'bud.q.expectedIncome.hint': 'Förväntade fakturerade intäkter för hela året.',
  'bud.q.goodsAnnual.label': 'Varuinköp',
  'bud.q.goodsAnnual.hint': 'Varor eller material du köper in för försäljning.',
  'bud.q.officeMonthly.label': 'Kontor/lokal per månad',
  'bud.q.officeMonthly.hint': 'Hyra, kontorsplats eller lokal.',
  'bud.q.softwareMonthly.label': 'Programvara per månad',
  'bud.q.softwareMonthly.hint': 'Abonnemang, verktyg och appar.',
  'bud.q.accountingMonthly.label': 'Redovisning/rådgivning per månad',
  'bud.q.accountingMonthly.hint': 'Redovisningskonsult, rådgivare eller hjälp.',
  'bud.q.travelAnnual.label': 'Bil/resor per år',
  'bud.q.travelAnnual.hint': 'Körning, resor, hotell eller transport.',
  'bud.q.marketingAnnual.label': 'Marknadsföring per år',
  'bud.q.marketingAnnual.hint': 'Annonser, profilering och försäljningskostnader.',
  'bud.q.otherAnnual.hint': 'Lägg in en buffert för det du inte vet ännu.',
  'aii.superPlumma': 'SuperPlumma',
  'aii.askSuperPlumma': 'Fråga SuperPlumma',
  'aii.chatWithSuperPlumma': 'Chatta med SuperPlumma',
  'aii.chatWithMe': 'Chatta med mig',
  'aii.healthScore': 'Ekonomisk hälsopoäng',
  'po.title': 'Privatekonomi',
  'po.backToBusiness': 'Tillbaka till företaget',
  'po.yourAdvisor': 'Din privata rådgivare',
  'po.intro': 'Privatekonomi är din personliga ekonomi — helt åtskild från företagets bokföring. SuperPlumma analyserar inkomster, konsumtion, sparande, lån, pension och skatt för hushållet och ger råd så som en privat finansiell rådgivare skulle göra. «Beta» betyder att funktionen fortfarande är under utveckling.',
  'po.hero.greeting.night': 'God natt.',
  'po.hero.greeting.morning': 'God morgon.',
  'po.hero.greeting.day': 'Hej.',
  'po.hero.greeting.evening': 'God kväll.',
  'po.hero.greetingNamed.night': 'God natt, {name}.',
  'po.hero.greetingNamed.morning': 'God morgon, {name}.',
  'po.hero.greetingNamed.day': 'Hej, {name}.',
  'po.hero.greetingNamed.evening': 'God kväll, {name}.',
  'po.hero.section.idag': 'Dagens råd',
  'po.hero.section.oversikt': 'Ekonomisk översikt',
  'po.hero.section.forbruk': 'Konsumtion',
  'po.hero.section.familie': 'Familjeekonomi',
  'po.hero.section.fremtid': 'Framtidsplan',
  'po.hero.section.reports': 'Rapporter',
  'po.hero.section.assets': 'Tillgångar',
  'po.hero.section.gjeld': 'Skulder',
  'po.hero.section.import': 'Dataunderlag',
  'po.hero.advice.idag': 'Jag håller koll på din ekonomi och lyfter fram de viktigaste uppgifterna och möjligheterna just nu.',
  'po.hero.advice.oversikt': 'Se vad som drar den ekonomiska hälsan upp och ner. Börja med det område som behöver mest uppföljning.',
  'po.hero.advice.forbruk': 'Leta efter kategorier som har ökat och välj en realistisk åtgärd som ger mer utrymme utan att göra vardagen för trång.',
  'po.hero.advice.familie': 'Klargör vad som är gemensamt, vem som betalar vad och vilka mål hushållet ska prioritera tillsammans.',
  'po.hero.advice.fremtid': 'Gör målen konkreta med belopp och datum. Då blir det lättare att se vad du bör spara varje månad.',
  'po.hero.advice.reports': 'Använd rapporterna för att förstå utvecklingen över tid, inte bara ett enskilt högt eller lågt månadsbelopp.',
  'po.hero.advice.assets': 'Kontrollera att värden och kontosaldon är uppdaterade innan du bedömer nettoförmögenhet och långsiktiga val.',
  'po.hero.advice.gjeld': 'Prioritera en trygg buffert först och överväg sedan extra amortering på skulden med högst effektiv ränta.',
  'po.hero.advice.import': 'Ett bra råd börjar med bra data. Koppla kontoutdragen till rätt konto och fyll i saknade perioder.',
  'po.pickPerson': 'Välj person',
  'po.sections': 'Sektioner',
  'po.sectionsHelp': 'Växla mellan områdena: I dag (dagens insikter), Översikt (hälsopoäng och nyckeltal), Konsumtion (vart pengarna tar vägen), Familj, Framtid (prognos och «vad händer om»), Rapporter, Tillgångar, Skulder, Skatt och Import.',
  'po.outOf100': 'av 100',
  'po.todaysFocus': 'Dagens fokus',
  'po.todaysTasks': 'Dagens uppgifter',
  'po.mostImportantToday': 'Viktigast i dag',
  'po.markDone': 'Markera som klar',
  'po.undo': 'Ångra',
  'po.healthHeading': 'Din samlade ekonomiska hälsa — och vad som påverkar den',
  'po.healthHelp': 'Talet i ringen (0–100) är en samlad bedömning av din ekonomi — ju högre, desto sundare. Kategorierna nedan visar vad som drar upp och ned: grönt är bra, gult betyder håll koll och rött behöver åtgärdas.',
  'po.noHistory': 'Ingen historik att jämföra med ännu',
  'po.whatAffectsScore': 'Vad påverkar poängen mest',
  'po.noDrivers': 'Inga drivkrafter beräknade ännu',
  'po.noDriversHelp': 'När det finns tillräckligt med importerade transaktioner visar jag vad som drar poängen upp och ned.',
  'po.last30Days': 'Senast registrerade månad',
  'po.last30DaysSub': 'Jämfört med föregående kalendermånad',
  'po.financialOverview': 'Ekonomisk översikt',
  'po.financialOverviewSub': 'En ögonblicksbild av hushållets ekonomi',
  'po.recommendations': 'SuperPlummas rekommendationer',
  'po.recommendationsSub': 'De åtgärder som betyder mest för din ekonomi just nu',
  'po.askMe': 'Fråga mig',
  'po.yourHealthScoreIs': 'Din hälsopoäng är',
  'po.adjustBudget': 'Justera budget',
  'po.budgetTotal': 'Summa budget:',
  'po.saveBudget': 'Spara budget',
  'po.monthlyLimitPerCategory': 'Månadsgräns per kategori',
  'po.noCategoriesImported': 'Inga utgiftskategorier har importerats ännu. Lägg till egna kategorier nedan.',
  'po.ownCategories': 'Egna kategorier',
  'po.pickColour': 'Välj färg',
  'po.categoryName': 'Kategorinamn',
  'po.removeCategory': 'Ta bort kategori',
  'po.addCategory': 'Lägg till kategori',
  'po.budgetVsSpending': 'Budget mot utgifter',
  'po.budgetVsSpendingSub': 'Månadsgräns mot utgifterna under vald period',
  'po.budgetVsSpendingHelp': 'Månadsbudget mot faktiska utgifter per kategori. Tryck på «Justera budget» för att ställa in gränserna eller skapa egna kategorier. Förloppsindikatorn fylls efter hur mycket av budgeten du har använt — grönt är inom ramen, gult närmar sig gränsen och rött betyder att kategorin är överskriden. Om du väljer årsöversikt multipliceras månadsgränsen med antalet månader som har importerade data. Budgetarna sparas för valt år.',
  'po.whereMoneyGoes': 'Vart går pengarna?',
  'po.whereMoneyGoesSub': 'Tryck på en kategori för att se transaktionerna bakom och flytta dem till rätt ställe',
  'po.whereMoneyGoesHelp': 'Cirkeldiagrammet och listan visar utgifterna fördelade på kategorier för vald period. Byt period med knappen överst — månader utan importerade transaktioner är grå. Tryck på en kategori för att markera den. Procenten till höger är förändringen mot föregående månad — grönt nedåt betyder mindre, rött uppåt betyder mer.',
  'po.selectPeriod': 'Välj period',
  'po.yearOverview': 'Årsöversikt',
  'po.yearly': 'Årlig',
  'po.month.1': 'Januari',
  'po.month.2': 'Februari',
  'po.month.3': 'Mars',
  'po.month.4': 'April',
  'po.month.5': 'Maj',
  'po.month.6': 'Juni',
  'po.month.7': 'Juli',
  'po.month.8': 'Augusti',
  'po.month.9': 'September',
  'po.month.10': 'Oktober',
  'po.month.11': 'November',
  'po.month.12': 'December',
  'po.largestCategoryIs': 'Största kostnadskategorin är',
  'po.recurringCharges': 'Återkommande dragningar att se över',
  'po.recurringChargesSub': 'Återkommande abonnemangsdragningar som kan vara värda att kontrollera',
  'po.opportunity': 'Möjlighet',
  'po.estimatedAnnualCost': 'Beräknad årskostnad',
  'po.saveAccount': 'Spara konto',
  'po.allAccounts': 'Alla konton',
  'po.uploadedStatements': 'Uppladdade kontoutdrag',
  'po.yourAccounts': 'Dina konton',
  'po.yourAccountsSub': 'Registrera och sortera dina konton efter typ — importerade kontoutdrag kopplas till rätt konto',
  'po.totalBalance': 'Summa behållning',
  'po.creditDebt': 'Kreditskuld',
  'po.accounts': 'Konton',
  'po.analysis': 'SuperPlummas analys',
  'po.analysisSub': 'Hur utgifterna i kategorin fördelar sig — och vad du kan göra',
  'po.whoIsBehind': 'Vem som ligger bakom',
  'po.noTransactionsToAnalyse': 'Inga transaktioner att analysera ännu.',
  'po.unusualPurchases': 'Ovanliga köp',
  'po.noUnusualPurchases': 'Inga köp sticker ut under denna period.',
  'po.searchTransactions': 'Sök i transaktioner …',
  'po.clearSearch': 'Rensa sökning',
  'po.sort': 'Sortera',
  'po.linkStatementToAccount': 'Koppla kontoutdrag till konto',
  'po.linkToAccount': 'Koppla till konto',
  'po.newAccount': 'Nytt konto',
  'po.accountNamePh': 'T.ex. DNB lönekonto',
  'po.accountNumberPh': 'T.ex. 1234.56.78901',
  'po.currentAccount': 'Lönekonto',
  'po.creditCard': 'Kreditkort',
  'po.me': 'jag',
  'po.importTitle': 'Importera ekonomiska data',
  'po.importSub': 'Ladda upp kontoutdrag — SuperPlumma läser och kategoriserar automatiskt',
  'po.pickStatement': 'Välj kontoutdrag från banken',
  'po.pickStatementHelp': 'Ladda upp kontoutdrag från banken. XLSX och CSV läses direkt, PDF läses så gott det går från texten. SuperPlumma kategoriserar transaktionerna automatiskt.',
  'po.pdf': 'PDF',
  'po.noStatementsUploaded': 'Inga kontoutdrag har laddats upp ännu.',
  'po.deleteStatement': 'Ta bort kontoutdrag',
  'po.sharedCosts': 'Bidrag till gemensamma kostnader',
  'po.sharedCostsSub': 'Vem betalar vad av de gemensamma utgifterna — och hur det står sig mot inkomstandelen',
  'po.sharedCostsHelp': 'Stapeln visar hur stor andel av hushållets gemensamma kostnader var och en av er står för. Till höger visas andelen av den samlade inkomsten. Om de två är lika stora är fördelningen proportionell mot inkomsten. Siffrorna kommer från det som var och en av er har lagt in på sin egen profil.',
  'po.splitIsEven': 'Fördelningen är jämn. Ni delar',
  'po.togetherYouCan': 'Tillsammans kan ni',
  'po.togetherYouCanSub': 'Små åtgärder ni kan ta som ett lag — beräknade utifrån hushållets egna siffror',
  'po.togetherHelp': 'Förslagen är beräknade utifrån den samlade inkomst och de gemensamma kostnader ni har lagt in. De är tänkta som gemensamma mål, inte krav på enskilda personer.',
  'po.sharedSteps': 'Gemensamma åtgärder',
  'po.magnitude': 'Storleksordning',
  'po.youPartnerPh': 'Du, partner …',
  'po.monthlyNetIncome': 'Månatlig nettoinkomst',
  'po.sharedCostShare': 'Andel gemensamma kostnader per månad',
  'po.familyFinances': 'Familjeekonomi',
  'po.addPerson': 'Lägg till person',
  'po.noHouseholdMembers': 'Inga hushållsmedlemmar har registrerats ännu.',
  'po.householdHasRegistered': 'Hushållet har registrerat',
  'po.todaysPlan': 'Dagens plan',
  'po.savePlan': 'Spara plan',
  'po.monthlySaving': 'Månatligt sparande (kr)',
  'po.monthlyExtraDebt': 'Månatlig extra amortering (kr)',
  'po.targetNetWealth': 'Önskad nettoförmögenhet (kr)',
  'po.expectedReturn': 'Förväntad årlig avkastning (%)',
  'po.yourAgeToday': 'Din ålder i dag (år)',
  'po.desiredRetirementAge': 'Önskad pensionsålder (år)',
  'po.pickEvent': 'Välj en händelse',
  'po.eventNamePh': 'T.ex. Barn nummer två',
  'po.starts': 'Startar',
  'po.oneOffCost': 'Engångskostnad (kr)',
  'po.monthlyEffect': 'Månatlig effekt (kr)',
  'po.durationMonths': 'Varaktighet (månader)',
  'po.goalName': 'Namn på målet',
  'po.goalNamePh': 'T.ex. Buffert',
  'po.shortDescription': 'Kort beskrivning',
  'po.whatSavingFor': 'Vad sparar du till?',
  'po.targetAmount': 'Målbelopp (kr)',
  'po.savedSoFar': 'Sparat hittills (kr)',
  'po.icon': 'Ikon',
  'po.colour': 'Färg',
  'po.debtFree': 'Skuldfri',
  'po.saveLoan': 'Spara lån',
  'po.loanType': 'Lånetyp',
  'po.spendingCategory': 'Kategori i Utgifter',
  'po.categoryPh': 'T.ex. Boende',
  'po.debtOverview': 'Skuldöversikt',
  'po.debtOverviewSub': 'Alla dina lån samlade — restskuld, räntor och amorteringstakt',
  'po.debtOverviewHelp': 'Nyckeltalen för alla dina skulder: samlad restskuld, vad du amorterar per månad, räntekostnader per år, snittränta och hur lång tid det tar tills du är skuldfri.',
  'po.totalDebt': 'Total skuld',
  'po.repaymentPerMonth': 'Amortering per månad',
  'po.interestPerYear': 'Ränta per år',
  'po.averageRate': 'Snittränta',
  'po.debtFreeIn': 'Skuldfri om',
  'po.loanCount': 'Antal lån',
  'po.yourLoans': 'Dina lån',
  'po.yourLoansSub': 'Tryck på ett lån för att se amorteringsplan och simulera ändringar',
  'po.addLoan': 'Lägg till lån',
  'po.noLoans': 'Inga lån inlagda ännu. Tryck på ”Lägg till lån” för att komma igång.',
  'po.whichLoanFirst': 'Vilka lån bör du betala av först?',
  'po.whichLoanFirstSub': 'Rangordnade efter ränta — det dyraste lånet först ger mest tillbaka för varje extra krona',
  'po.iRecommend': 'Jag rekommenderar',
  'po.snowballWithRate': 'räntemetoden (lavinmetoden)',
  'po.repaymentSimSub': 'Se hur restskulden minskar och simulera vad som händer om du betalar mer eller mindre per månad',
  'po.myRecommendation': 'Min rekommendation',
  'po.withChange': 'Med ändring',
  'po.extraRepaymentPerMonth': 'Extra amortering per månad',
  'po.dragToPayMore': 'Dra för att betala mer (snabbare skuldfri) eller mindre (längre löptid)',
  'po.standard': 'Standard',
  'po.savedInInterest': 'Sparat i ränta',
  'po.overWholeTerm': 'under hela löptiden',
  'po.netWealthEffect': 'Effekt på nettoförmögenhet',
  'po.becomesYours': 'blir din, inte bankens',
  'po.interestPostedAs': 'Ränta och amortering på det här lånet bokförs som',
  'po.debtJourney': 'Din skuldresa',
  'po.debtJourneySub': 'De viktigaste milstolparna på vägen mot att bli helt skuldfri',
  'po.yourFinancialFuture': 'Din ekonomiska framtid',
  'po.yourFinancialFutureSub': 'Vart pengarna tar dig — och hur dina val formar vägen dit',
  'po.showingScenario': 'Visar scenario:',
  'po.reset': 'Återställ',
  'po.desiredNetWealth': 'Önskad nettoförmögenhet',
  'po.lastsUntilYouAre': 'räcker tills du är',
  'po.lasts': 'räcker',
  'po.forLife': 'livet ut',
  'po.plummaReadsChart': 'SuperPlumma läser diagrammet',
  'po.whatIf': 'Vad händer om?',
  'po.whatIfSub': 'Utgå från Dagens plan, välj ett beslut och justera antagandena — så uppdateras diagrammet, målen, datumen och pensionen samtidigt',
});
